import { SettingsService } from "@/services/settings-service"

/**
 * Whether the current user may create/share flows (Fas 1a).
 *
 * Mirrors the backend `creation_allowed` rule: under the "restricted" policy
 * only workflow admins may create; otherwise anyone can. Running existing flows
 * is never gated by this.
 */
export function canCreateFlows(): boolean {
  const settings = SettingsService.getInstance().settings
  const policy = settings.flowCreationPolicy ?? "everyone"
  if (policy !== "restricted") return true
  // `settings` starts life as `{} as Config` until /auth/config resolves, so
  // `user_policy` is genuinely undefined during the startup race — the optional
  // chain is necessary at runtime despite the type. Fail closed (undefined →
  // non-admin); the backend enforces the creation policy (403) independently.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return Boolean(settings.user_policy?.is_workflow_admin)
}
